import React, { useState } from 'react'
import useLogout from '../../hooks/useLogout';
import { changePassword } from '../../services/auth';
import { Button, Dropdown, Modal, Nav, Navbar } from 'react-bootstrap';
import { FaSignOutAlt } from 'react-icons/fa';
import Message from './Message';
import ChangePassword from '../forms/auth/ChangePassword';

const Header = () => {
    const [ showModal, setShowModal ] = useState(false);
    const logout = useLogout();
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const [messageText, setMessageText] = useState('');
    const [messageVariant, setMessageVariant] = useState('');
    const [showMessage, setShowMessage] = useState(false);

    const handleCloseMessage = () => {
        setShowMessage(false);
    }

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const handleSignOut = async () => {
        await logout();
        handleCloseModal();
    }

    const handleClosePasswordModal = () => {
        setShowPasswordModal(false);
        setIsSaving(false);
    }

    const handleShowChangePasswordModal = () => setShowPasswordModal(true);

    const handleChangePassword = async (data) => {
        setIsSaving(true);

        try {
            const passwordData = {
                current_password: data.current_password,
                password: data.password,
                password_confirmation: data.password_confirmation
            };

            await changePassword(passwordData);
            setMessageText('Password successfully changed');
            setMessageVariant('success');
            setShowMessage(true);

            return true;
        } catch (error) {
            if (error.response.status === 500 && error.response){
                setMessageText('An internal error occurred whilst changing password: ' + error.response.data.message);
                setMessageVariant('danger');
                setShowMessage(true);

                return false;
            } else if (error.response.status === 401 && error.response) {
                setMessageText('Unathorized. Try again later');
                setMessageVariant('danger');
                setShowMessage(true);

                return false;
            } else if (error.response.status === 422 && error.response) {
                throw error; // validation errors to be handled in onSubmit() in ChangePasswordForm.jsx
            } else {
                setMessageText('An error occurred whilst changing password. Try again later');
                setMessageVariant('danger');
                setShowMessage(true);

                return false;
            }
        } finally {
            await new Promise((resolve) => setTimeout(resolve, 500));
            setIsSaving(false);
        }
    } 
  return (
    <>
        <Navbar expand="lg">
            <Navbar.Brand href='/'>Tracktual</Navbar.Brand>
            <Nav className='ms-auto'>
                <Dropdown>
                    <Dropdown.Toggle variant='secondary' id='dropdwon-basic'>
                        Hello, John Doe
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={handleShowChangePasswordModal}>
                            Change Password
                        </Dropdown.Item>
                        <Dropdown.Item onClick={handleShowModal}>
                            <FaSignOutAlt /> Sign Out
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Nav>
            
        </Navbar>    

        <Modal show={showPasswordModal} onHide={handleClosePasswordModal}>
            <Modal.Header closeButton>
                <Modal.Title>Change Password</Modal.Title>
            </Modal.Header>

            <Message
                message={messageText}
                variant={messageVariant}
                handleClose={handleCloseMessage}
                show={showMessage}
            />

            <ChangePassword
                isSaving={isSaving}
                formAction={handleChangePassword}
            />

        </Modal>

        <Modal show={showModal} onHide={handleCloseModal}>

            <Modal.Header closeButton>
                <Modal.Title>Confirm Sign Out</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to sign out?</Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleCloseModal}>
                    Cancel
                </Button>

                <Button className='btn-custom' onClick={handleSignOut}>
                    <FaSignOutAlt /> Sign Out
                </Button>
            </Modal.Footer>
        </Modal>
    </>
  )
}

export default Header